import _ from 'lodash';
import moment from 'moment';
import BaseAccountController from '../../lib/controllers/BaseAccountController';
import queryParameterParser from '../../lib/helpers/queryStringParser';

declare var LtFramework: lt.Static;

interface IResourceKeyEx extends MyAccountApi.IResourceKey {
	visitsRemaining: number; // number of visits remaining
}

export default class DayPassDetailsController extends BaseAccountController {
	public static $inject: string[] = ['$window', '$scope', 'ClubVisitResource', 'Profile'];

	public dayPass: lt.IResourceKey[] = [];
	public allClubVisits: MyAccountApi.IClubVisit[];

	private readonly $window: ng.IWindowService;
	private readonly ClubVisit: MyAccountApi.IClubVisitResource;

	constructor($window: ng.IWindowService, $scope: ng.IScope, ClubVisit: MyAccountApi.IClubVisitResource, Profile: lt.IProfile) {
		super($scope, Profile);

		this.$window = $window;
		this.ClubVisit = ClubVisit;
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		// grab params for club visits call
		const keyOwnerId = queryParameterParser.getParameterByName(this.$window, 'key_owner_id');
		const startDate = queryParameterParser.getParameterByName(this.$window, 'start_date');
		const endDate = queryParameterParser.getParameterByName(this.$window, 'end_date');
		// update day pass package information
		this.getDayPassPackageInfo();
		// load club visits
		this.ClubVisit.query({
			key_owner_id: keyOwnerId,
			start_date: startDate,
			end_date: endDate
		}, this.updateClubVisits.bind(this));
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}

	private updateClubVisits(clubVisits: MyAccountApi.IClubVisit[]): void {
		this.allClubVisits = clubVisits;
		this.allClubVisits.forEach((v) => {
			// set date property for sorting purposes
			(v).usageTime = moment(v.usageDateTime).format('H:mm A');
		});
	}

	private getDayPassPackageInfo(): void {
		const keyOwnerId = queryParameterParser.getParameterByName(this.$window, 'key_owner_id');
		this.dayPass = _.filter(this.profile.memberDetails!.resourceKeys, (o: lt.IResourceKey) => {
			return o.ltfKeyOwnerId.toString() === keyOwnerId;
		});
		this.dayPass.forEach((o: lt.IResourceKey) => {
			o.fromDate = moment(o.fromDate).format('MMM D, YYYY');
			o.thruDate = moment(o.thruDate).format('MMM D, YYYY');
			// set visits remaining property
			(o as IResourceKeyEx).visitsRemaining = o.usageLimit - o.usageCount;
		});
	}
}
